import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { numberWithCommas } from 'helper';
import _ from 'lodash';

function PermitForm({ data }) {
  const lineOfBusiness = _.get(data, 'included.businessActivities');
  return (
    <React.Fragment>
      <div className="row">
        <div className="col">
          <h3 className="mb-3">Business Permit and Licensing System</h3>
        </div>
      </div>
      <div className="permit-format">
        <div className="form-wrapper mb-3">
          <div className="full-group border-bottom">
            <div className="form-row">
              <div className="form-input-group col-8 border-right">
                <label htmlFor="business_owner_name" className="full-label mb-0">
                  Owner Name
                </label>
                <span className="full-input">
                  {_.get(data, 'attributes.business_owner_name') || '--'}
                </span>
              </div>
              <div className="form-input-group col-4">
                <label htmlFor="business_owner_gender" className="full-label mb-0">
                  Gender
                </label>
                <span className="full-input">
                  {_.get(data, 'attributes.business_owner_gender') || '--'}
                </span>
              </div>
            </div>
          </div>
          <div className="full-group border-bottom">
            <div className="form-row">
              <div className="form-input-group col-12">
                <label htmlFor="business_name" className="full-label mb-0">
                  Business Name
                </label>
                <span className="full-input">
                  {_.get(data, 'attributes.business_name') || '--'}
                </span>
              </div>
            </div>
          </div>
          <div className="full-group border-bottom">
            <div className="form-row">
              <div className="form-input-group col-12">
                <label htmlFor="trade_franchise_name" className="full-label mb-0">
                  Trade Name / Franchise
                </label>
                <span className="full-input">
                  {_.get(data, 'attributes.trade_franchise_name') || '--'}
                </span>
              </div>
            </div>
          </div>
          <div className="full-group">
            <div className="form-row">
              <div className="form-input-group col-12">
                <label className="full-label mb-0">
                  Business Address
                </label>
                <div className="full-group">
                  <div className="form-row">
                    <div className="form-input-group border-right col-12 col-md-6">
                      <label className="full-label mb-0">Barangay</label>
                      <span className="full-input">
                        {_.get(data, 'attributes._barangay_name') || '--'}
                      </span>
                    </div>
                    <div className="form-input-group col-12 col-md-6">
                      <label className="full-label mb-0">Street/Unit/Bldg/Village</label>
                      <span className="full-input">
                        {_.get(data, 'attributes.business_address') || '--'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-wrapper mb-3">
          <div className="full-group border-bottom">
            <div className="form-row">
              <div className="form-input-group col-6 border-right">
                <label htmlFor="organization_type_id" className="full-label mb-0">
                  Kind Of Organization
                </label>
                <span className="full-input">
                  {_.get(data, 'attributes._organization_type_name') || '--'}
                </span>
              </div>
              <div className="form-input-group col-6">
                <label htmlFor="total_number_personnel" className="full-label mb-0">
                  Total Number of Personnel
                </label>
                <div className="full-group">
                  <div className="form-row">
                    <div className="form-input-group col-6 border-right d-flex justify-content-start">
                      <label className="full-label mb-0">Male:</label>
                      <span className="full-input">
                        {_.get(data, 'attributes.total_male_personnel') || '--'}
                      </span>
                    </div>
                    <div className="form-input-group col-6 d-flex justify-content-start">
                      <label className="full-label mb-0">Female:</label>
                      <span className="full-input">
                        {_.get(data, 'attributes.total_female_personnel') || '--'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="full-group border-bottom">
            <div className="form-row">
              <div className="form-input-group col-6 border-right">
                <label htmlFor="tin_number" className="full-label mb-0">
                  Taxpayer Identification Number
                </label>
                <span className="full-input">
                  {_.get(data, 'attributes.tin_number') || '--'}
                </span>
              </div>
              <div className="form-input-group col-6">
                <label htmlFor="tin_number" className="full-label mb-0">
                  Service Unit.
                </label>
                <span className="full-input">
                  {_.get(data, 'attributes.service_unit') || '--'}
                </span>
              </div>
            </div>
          </div>
          <div className="full-group border-bottom">
            <div className="form-row">
              <div className="form-input-group col-6 border-right">
                <label
                  htmlFor="dti_sec_cda_registration_number"
                  className="full-label mb-0"
                >
                  {_.get(data, 'attributes._organization_type_requirement_name') || '--'} Registration No.
                </label>
                <span className="full-input">
                  {_.get(data, 'attributes.dti_sec_cda_registration_number') || '--'}
                </span>
              </div>
              <div className="form-input-group col-6 ">
                <label htmlFor="dti_sec_cda_registration_date" className="full-label mb-0">
                  {_.get(data, 'attributes._organization_type_requirement_name') || '--'} Registration Date
                </label>
                <span className="full-input">
                  {moment(_.get(data, 'attributes.dti_sec_cda_registration_date')).format('ll')}
                </span>
              </div>
            </div>
          </div>
          <div className="full-group">
            <div className="form-row">
              <table className="table table-borderless table-sm w-100">
                <thead>
                  <tr>
                    <td>
                      <div className="form-input-group">
                        <label className="full-label mb-0">Line of Business</label>
                      </div>
                    </td>
                    <td>
                      <div className="form-input-group">
                        <label className="full-label mb-0">Nature of Business</label>
                      </div>
                    </td>
                    <td>
                      <div className="form-input-group">
                        <label className="full-label mb-0 d-flex justify-content-between">
                          Capital Investment
                        </label>
                      </div>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {(lineOfBusiness || []).length > 0 ? (
                    (lineOfBusiness || []).map(item => (
                      <tr key={`${item.id}`}>
                        <td className="pb-0">
                          <p className="px-2 mb-0">{_.get(item, 'attributes._line_business_name') || '--'}</p>
                        </td>
                        <td className="pb-0">
                          <p className="px-2 mb-0">{_.get(item, 'attributes._nature_business_name') || '--'}</p>
                        </td>
                        <td className="pb-0">
                          <p className="px-2 mb-0">{'\u20B1'} {numberWithCommas(_.get(item, 'attributes.capitalization', 0) || 0)}</p>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">
                        <div className="d-flex align-items-center justitfy-content-center h-100">
                          <div className="text-center mx-auto">
                            <p className="emp-title mb-0">Empty</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

PermitForm.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default PermitForm;
